import React from "react";
import styled from "styled-components";

export default function AmbientBackground() {
  return (
    <Ambient>
      <GridGlow />
    </Ambient>
  );
}

const Ambient = styled.div`
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 0;
  overflow: hidden;

  @media (hover: none) and (pointer: coarse) {
    /* heavy blurs make Safari janky on touch devices — fall back to the global background */
    display: none;
  }
`;

const GridGlow = styled.div`
  position: absolute;
  inset: 0;
  opacity: 0.12;
  background: linear-gradient(
        90deg,
        rgba(255, 255, 255, 0.08) 1px,
        transparent 1px
      )
      0 0 / 24px 24px,
    linear-gradient(0deg, rgba(255, 255, 255, 0.08) 1px, transparent 1px) 0 0 /
      24px 24px;
  animation: none;
`;
